
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public/whySell",
      function () {
        return require("private-next-pages/public/whySell.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public/whySell"])
      });
    }
  